import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-477e57ac")

_pushScopeId("data-v-477e57ac")
const _hoisted_1 = { class: "enterprise" }
const _hoisted_2 = { class: "enterprise-head" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "enterprise-head__title" }, [
  /*#__PURE__*/_createVNode("span", { class: "title" }, "编辑企业")
], -1)
const _hoisted_4 = { class: "enterprise-head__action" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = { style: {"display":"flex","align-items":"center","flex-wrap":"wrap","gap":"10px 20px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("智享数字车管")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("蓝鲸车管家")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("交通卫星")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("自定类型")
const _hoisted_14 = {
  key: 0,
  style: {"margin-top":"10px","margin-left":"20px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("EP模式")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("集采模式")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("https://")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(".ccclubs.com")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("自动")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("非自动")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("不支持")
const _hoisted_24 = { style: {"margin-top":"4px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("支持")
const _hoisted_26 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { style: {"margin-right":"5px"} }, "数量", -1)
const _hoisted_28 = {
  key: 0,
  class: "custom-error"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("不支持")
const _hoisted_30 = { style: {"margin-top":"4px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("支持")
const _hoisted_32 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { style: {"margin-right":"5px"} }, "数量", -1)
const _hoisted_34 = {
  key: 0,
  class: "custom-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_c_upload = _resolveComponent("c-upload")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, { onClick: _ctx.back }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.creatSumbit
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules,
      "label-width": "80px",
      "label-position": "top",
      class: "enterprise-form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "含有子公司",
                  prop: "collectivized"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.collectivized,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.collectivized = $event)),
                      disabled: _ctx.formData.affiliated
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withId(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withId(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "客户类型",
                  prop: "customerType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.customerType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.customerType = $event))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customerTypeOpt, (i, k) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            key: k,
                            label: i.value
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(i.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "系统类型",
                  prop: "systemType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.systemType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.systemType = $event)),
                      style: {"display":"block"}
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_el_radio, { label: 2 }, {
                            default: _withId(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 3 }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 4 }, {
                            default: _withId(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]),
                        (_ctx.formData.systemType === 4)
                          ? (_openBlock(), _createBlock("div", _hoisted_14, [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.techProvider,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.techProvider = $event)),
                                placeholder: "填写企业名称",
                                style: {"width":"200px"},
                                maxlength: "50"
                              }, null, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业编号",
                  prop: "enterpriseCode"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.enterpriseCode,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.enterpriseCode = $event)),
                      disabled: "",
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业名称",
                  prop: "name"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.name,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.name = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "系统模式",
                  prop: "systemPattern"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.systemPattern,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.systemPattern = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withId(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 2 }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "组织机构代码",
                  prop: "orgCode"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.orgCode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.orgCode = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经济类型" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.economicsType,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.economicsType = $event)),
                      modelModifiers: { number: true },
                      placeholder: "请选择"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.economicsTypeMap, (item, key) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item,
                            value: Number(key),
                            key: key
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经营状况" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.economicsStatus,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.economicsStatus = $event)),
                      modelModifiers: { number: true },
                      placeholder: "请选择"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.economicsStatusMap, (item, key) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item,
                            value: Number(key),
                            key: key
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证字",
                  prop: "manageCard"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.manageCard,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.manageCard = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证号",
                  prop: "manageCardNum"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.manageCardNum,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.manageCardNum = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证有效期起",
                  prop: "manageTimeStar"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.manageTimeStar,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.manageTimeStar = $event)),
                      type: "date",
                      placeholder: "选择日期",
                      onChange: _ctx.changeManageTimeStar
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证有效期止",
                  prop: "manageTimeEnd"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.manageTimeEnd,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.manageTimeEnd = $event)),
                      type: "date",
                      placeholder: "选择日期",
                      onChange: _ctx.changeManageTimeEnd
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证初次发证日期",
                  prop: "manageTimeFirst"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.manageTimeFirst,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.manageTimeFirst = $event)),
                      type: "date",
                      placeholder: "选择日期",
                      onChange: _ctx.changeManageTimeFirst
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营许可证发证机关",
                  prop: "cardOrg"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.cardOrg,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.cardOrg = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "注册地址",
                  prop: "signAddress"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.signAddress,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.signAddress = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "企业简称",
                  prop: "abbrName"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.abbrName,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.abbrName = $event)),
                      placeholder: "请输入1-8字"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "系统名称",
                  prop: "systemName"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.systemName,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.systemName = $event)),
                      placeholder: "请输入1-8字"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "短信收费",
                  prop: "chargeSms"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.chargeSms,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.chargeSms = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withId(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 0 }, {
                          default: _withId(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "独立访问地址",
                  prop: "domainHeader"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.domainHeader,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.domainHeader = $event)),
                      placeholder: "请输入"
                    }, {
                      prepend: _withId(() => [
                        _hoisted_19
                      ]),
                      append: _withId(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "违章同步",
                  prop: "violationSync"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.violationSync,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formData.violationSync = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio, { label: 1 }, {
                          default: _withId(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: 2 }, {
                          default: _withId(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "锐明userSecret",
                  prop: "aebUserSecret"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.aebUserSecret,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.formData.aebUserSecret = $event)),
                      placeholder: "请输入",
                      maxlength: "128"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "经营范围",
                  prop: "manageScope"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.manageScope,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.formData.manageScope = $event)),
                      type: "textarea",
                      placeholder: "请输入",
                      autosize: { minRows: 2, maxRows: 4 }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "违章备案" }, {
                  default: _withId(() => [
                    _createVNode("div", null, [
                      _createVNode(_component_el_radio, {
                        label: 1,
                        modelValue: _ctx.formData.violationContractAdd,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.formData.violationContractAdd = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_el_radio, {
                        label: 2,
                        modelValue: _ctx.formData.violationContractAdd,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.formData.violationContractAdd = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.formData.violationContractAdd === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_26, [
                            _hoisted_27,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.violationContractAddCount,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.formData.violationContractAddCount = $event)),
                              placeholder: "如有限制填写，为空则不限",
                              style: {"width":"200px"},
                              maxlength: "7"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.violationContractAddCountError)
                      ? (_openBlock(), _createBlock("div", _hoisted_28, _toDisplayString(_ctx.violationContractAddCountError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "违章转移" }, {
                  default: _withId(() => [
                    _createVNode("div", null, [
                      _createVNode(_component_el_radio, {
                        label: 1,
                        modelValue: _ctx.formData.violationContractTransfer,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.formData.violationContractTransfer = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_el_radio, {
                        label: 2,
                        modelValue: _ctx.formData.violationContractTransfer,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.formData.violationContractTransfer = $event))
                      }, {
                        default: _withId(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.formData.violationContractTransfer === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_32, [
                            _hoisted_33,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.violationContractTransferCount,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.formData.violationContractTransferCount = $event)),
                              placeholder: "如有限制填写，为空则不限",
                              style: {"width":"200px"},
                              maxlength: "7"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.violationContractTransferCountError)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, _toDisplayString(_ctx.violationContractTransferCountError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "电子合同集采方",
                  prop: "electronicType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.electronicType,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.formData.electronicType = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_option, {
                          label: "车厘子原APPID",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "车网新APPID",
                          value: 2
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "注册资本（万元）",
                  prop: "signMoney"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入",
                      modelValue: _ctx.formData.signMoney,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.formData.signMoney = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "联系人",
                  prop: "contacts"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.contacts,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.formData.contacts = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "联系电话",
                  prop: "contactsPhone"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.contactsPhone,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.formData.contactsPhone = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "法定代表",
                  prop: "legalPerson"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.legalPerson,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.formData.legalPerson = $event)),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "联系地址",
                  prop: "contactsAddress"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_col, {
                          span: 6,
                          lg: 8,
                          xl: 6
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_cascader, {
                              ref: "contactsAreaCode",
                              modelValue: _ctx.formData.contactsAreaCode,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.formData.contactsAreaCode = $event)),
                              onChange: _ctx.handleCContactsArea,
                              options: _ctx.accountAddressOptions
                            }, null, 8, ["modelValue", "onChange", "options"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          span: 6,
                          lg: 8,
                          xl: 6,
                          style: {"margin-left":"10px"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.contactsAddress,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.formData.contactsAddress = $event)),
                              placeholder: "请输入"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "营业执照" }, {
                  default: _withId(() => [
                    _createVNode(_component_c_upload, {
                      action: _ctx.action,
                      headers: _ctx.headers,
                      multiple: false,
                      maxSize: 2024,
                      fileList: _ctx.businessLicenseJpgList,
                      onOnSuccess: _ctx.uploadBLSuccess,
                      onOnRemove: _ctx.uploadBLRemove
                    }, null, 8, ["action", "headers", "fileList", "onOnSuccess", "onOnRemove"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "经营许可证" }, {
                  default: _withId(() => [
                    _createVNode(_component_c_upload, {
                      action: _ctx.action,
                      headers: _ctx.headers,
                      multiple: false,
                      maxSize: 2024,
                      fileList: _ctx.managePermissionJpgList,
                      onOnSuccess: _ctx.uploadMPSuccess,
                      onOnRemove: _ctx.uploadMPRemove
                    }, null, 8, ["action", "headers", "fileList", "onOnSuccess", "onOnRemove"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "状态",
                  prop: "enterpriseStatus"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.enterpriseStatus,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.formData.enterpriseStatus = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_option, {
                          label: "正常",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "禁用",
                          value: 2
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})